import angular from "angular";

import AdminServiceProvidersModuleRouting from "./admin-service-providers.module.routing";

export default angular
  .module("vt-admin-service-providers", [])
  .config(AdminServiceProvidersModuleRouting);
